import React, {Fragment} from "react"
import classNames from "classnames"
import {getCurrentSeason} from "utils/date_utils"
import "./RescuerSeasons.css"

export default function RescuerSeasons(props) {
    
    const {rescuer} = props
    
    console.log("DDD", rescuer.seasons)
    
    if (Object.keys(rescuer.seasons ?? {}).length === 0) return <p id="rescuer-seasons">Nema overenih licenci</p>
    
    return <div id="rescuer-seasons">
        <div id="table">
            <strong>Godina</strong>
            <strong>Koeficijent</strong>
            <strong>Članarina</strong>
            <strong>Rang</strong>
                            
            {Object.entries(rescuer.seasons).map(([season, data]) => <Fragment key={season}>
                  <div className="center">{season}</div>
                  <div className={classNames({"not": !(data.coef > 0)})}>{data.coef > 0 ? <>{data.coef.toFixed(8)}</> : "nema overenu licencu"}</div>
                  <div className={classNames("center", {"not": !data.membership_paid})}>
                      {parseInt(season) >= 2025 && <>
                          {data.membership_paid ? <i className="fa-solid fa-check"/> : <i className="fa-solid fa-xmark"/>}
                      </>}
                  </div>
                  <div className="center">{data.rank}</div>
            </Fragment>)}
        </div>
    </div>

}